var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnionLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 54,
    viewBox: "0 0 88 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.2583 53.2304H36.1199L45.5614 43.9729C46.509 43.0118 47.6426 42.2526 48.8936 41.7414C50.1446 41.2301 51.4868 40.9775 52.8388 40.999H61.2738C63.6144 40.9913 65.9172 40.4097 67.9788 39.3054C70.0406 38.2011 71.7978 36.6081 73.0955 34.667C74.3931 32.7259 75.1914 30.4964 75.4197 28.1752C75.6482 25.8539 75.2996 23.5124 74.4049 21.3571C73.5102 19.2019 72.0968 17.2992 70.2896 15.8171C68.4823 14.3349 66.3368 13.3187 64.0422 12.8583C61.7476 12.3978 59.3745 12.5073 57.1324 13.177C54.8902 13.8466 52.8481 15.0559 51.186 16.6981L17.6126 50.2564C16.6651 51.2175 15.5313 51.9768 14.2803 52.488C13.0293 52.9992 11.687 53.2518 10.3351 53.2304H-3.0625L42.4065 7.79168C45.5139 4.69658 49.3394 2.41311 53.5442 1.14358C57.749 -0.125946 62.2032 -0.342301 66.512 0.513695C70.8208 1.36969 74.851 3.27159 78.2458 6.05088C81.6405 8.83013 84.2948 12.401 85.9734 16.4468C87.652 20.4927 88.303 24.8887 87.8689 29.2453C87.4347 33.6019 85.9286 37.7844 83.4844 41.4223C81.04 45.0602 77.7329 48.0412 73.8559 50.1008C69.979 52.1606 65.6519 53.2355 61.2583 53.2304Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnionLeft);
export default __webpack_public_path__ + "static/media/union_left.b2429b958e5992a1751133547fac003e.svg";
export { ForwardRef as ReactComponent };